import { useRolodexEntries } from 'features/rolodex'
import { RolodexEntryType } from 'types'

export const useRooftopKestrelModels = (
  unitId: string | undefined,
  options?: {
    enableFreshData?: boolean
  }
) => {
  const { entries: components } = useRolodexEntries(
    unitId
      ? {
          type: RolodexEntryType.COMPONENT,
          tags: { unit: unitId },
        }
      : undefined
  )

  const { entries: kestrelModels, isLoading } = useRolodexEntries(
    components && components.length > 0
      ? {
          type: RolodexEntryType.KESTREL_MODEL,
          tags: { unit: unitId },
        }
      : undefined,
    options?.enableFreshData
      ? {
          swrOptions: {
            revalidateIfStale: true,
            revalidateOnFocus: true,
            revalidateOnReconnect: true,
            dedupingInterval: 0,
          },
        }
      : undefined
  )

  return { kestrelModels, isLoading }
}
